import script from "./ButtonReaction.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonReaction.vue?vue&type=script&setup=true&lang=js"

import "./ButtonReaction.vue?vue&type=style&index=0&id=98b1b804&lang=scss"

const __exports__ = script;

export default __exports__